<template>
  <base-crud-page-list
      v-if="permissions.TASK_READ"
      :title="$tc('menu.task', 2)"
      :create-url="{ name: 'mainTasksCreate' }"
      :create-show="permissions.TASK_CREATE"
      :footer-show="record.pageCount > 1"

      model="">
    <template #filter>
      <button class="btn az_base_btn btn-primary mr-3" style="margin-bottom: 1rem" @click="check">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
             style="margin-right: 8px">
          <path
              d="M7.99967 1.33331C4.31967 1.33331 1.33301 4.31998 1.33301 7.99998C1.33301 11.68 4.31967 14.6666 7.99967 14.6666C11.6797 14.6666 14.6663 11.68 14.6663 7.99998C14.6663 4.31998 11.6797 1.33331 7.99967 1.33331ZM11.333 8.66665H8.66634V11.3333H7.33301V8.66665H4.66634V7.33331H7.33301V4.66665H8.66634V7.33331H11.333V8.66665Z"
              fill="white"/>
        </svg>
        {{ $t('create') }}
      </button>
      <base-input-search
          class="mr-3"
          is-filter
          @update:value="HandleParams('search', $event)"
      ></base-input-search>

      <base-input-deadline-type
          class="mr-3"
          is-filter
          @update:value="HandleParams('deadlineType', $event)"
      ></base-input-deadline-type>

      <base-input-deadline
          class="mr-3"
          is-filter
          :label-text="$t('deadlineDate')"
          @update:value="HandleParams('deadline', $event)"
      ></base-input-deadline>

      <base-input-project
          class="mr-3"
          is-filter
          :resource="projectList"
          :show-organization="$store.state.userProfile.systemAdmin"
          :value.sync="projectSelected"
          @update:value="HandleParams('project', $event)"
      ></base-input-project>

      <base-input-column
          external
          :resource="columnList"
          is-filter
          :disabled="!params.projectId"
          :value.sync="columnSelected"
          @update:value="HandleParams('column', $event)"
      ></base-input-column>


      <form @submit.prevent="submit">
        <div class="modal fade  nd_modal" id="modalTasks" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true" @click.self="clearModal">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" @click="clearModal" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body nd_modal_pages">
                <div class="nd_modal_block">

                  <div class="nd_create_item">
                    <p class="nd_p_text24 nd_color_black mb-1">{{ $t('newTask') }}</p>
                    <p v-if="!record.list.length" class="nd_p_text14 nd_color_grey mb-4">{{
                        $t("startFromScratch")
                      }}</p>
                    <div class="nd_base_form_gr mb-3">
                      <img src="../../../../../public/img/ereader.png" alt="">
                      <input class="form-control nd_base_inp"
                             type="text"
                             :placeholder="$t('taskName')"
                             :class="{'is-invalid': $v.createTaskModel.name.$error}"
                             v-model.trim="$v.createTaskModel.name.$model"
                      >
                    </div>
                    <div class="nd_base_form_gr mb-5">
                      <img src="../../../../../public/img/archive-book.png" alt="">
                      <select class="form-control nd_base_inp"
                              :class="{'is-invalid': $v.createTaskModel.projectId.$error}"
                              v-model="$v.createTaskModel.projectId.$model"
                      >
                        <option :value="0" disabled selected>{{ $tc('menu.project', 1) }}</option>
                        <option :key="item.id" v-for="item in projectList" :value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                    <button type="submit" :disabled="disabledBtn" class="btn btn-primary az_base_btn ">
                      {{ disabledBtn ? $t('loading') : $t('create') }}
                    </button>
                  </div>
                  <div class="img_create">
                    <img src="../../../../../public/img/businessman.png" alt="">
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="modal fade show nd_modal" id="projectNotFound" role="dialog"
           aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div style="max-width: 550px" class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content" style="min-height: 200px !important;">
            <div class="modal-body nd_modal_pages" style="display: block">
              <div class="img_create d-flex justify-content-center">
                <img src="../../../../../public/img/info_dtm.png" alt="">
              </div>
              <div style="text-align: center">
                <h3 style="font-weight: 600">{{ $t('projectNotFound') }}</h3>
                <p class="pt-2">{{ $t('projectNotFoundDesc') }}</p>
                <div class="pt-4" style="display: flex; justify-content: center; ">
                  <a class="btn az_base_btn btn-primary mr-3" href="/main/projects/index">
                    {{ $t('createProject') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>

    <template #table>
      <div class="nd_crud_table" style=" border-radius: 6px 6px 0 0;  overflow: hidden">
        <div class="nd_table_status">


          <button :class="{ 'active': params.ownTask === false }"
                  @click="HandleParams('ownTask1', !$event.target.classList.contains('active'))"
                  class="nd_btn_inc  mr-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                  d="M10.7934 1.33337H5.20671C2.78004 1.33337 1.33337 2.78004 1.33337 5.20671V10.7934C1.33337 13.22 2.78004 14.6667 5.20671 14.6667H10.7934C13.22 14.6667 14.6667 13.22 14.6667 10.7934V5.20671C14.6667 2.78004 13.22 1.33337 10.7934 1.33337ZM6.64671 9.93337L5.14671 11.4334C5.04671 11.5334 4.92004 11.58 4.79337 11.58C4.66671 11.58 4.53337 11.5334 4.44004 11.4334L3.94004 10.9334C3.74004 10.74 3.74004 10.42 3.94004 10.2267C4.13337 10.0334 4.44671 10.0334 4.64671 10.2267L4.79337 10.3734L5.94004 9.22671C6.13337 9.03337 6.44671 9.03337 6.64671 9.22671C6.84004 9.42004 6.84004 9.74004 6.64671 9.93337ZM6.64671 5.26671L5.14671 6.76671C5.04671 6.86671 4.92004 6.91337 4.79337 6.91337C4.66671 6.91337 4.53337 6.86671 4.44004 6.76671L3.94004 6.26671C3.74004 6.07337 3.74004 5.75337 3.94004 5.56004C4.13337 5.36671 4.44671 5.36671 4.64671 5.56004L4.79337 5.70671L5.94004 4.56004C6.13337 4.36671 6.44671 4.36671 6.64671 4.56004C6.84004 4.75337 6.84004 5.07337 6.64671 5.26671ZM11.7067 11.08H8.20671C7.93337 11.08 7.70671 10.8534 7.70671 10.58C7.70671 10.3067 7.93337 10.08 8.20671 10.08H11.7067C11.9867 10.08 12.2067 10.3067 12.2067 10.58C12.2067 10.8534 11.9867 11.08 11.7067 11.08ZM11.7067 6.41337H8.20671C7.93337 6.41337 7.70671 6.18671 7.70671 5.91337C7.70671 5.64004 7.93337 5.41337 8.20671 5.41337H11.7067C11.9867 5.41337 12.2067 5.64004 12.2067 5.91337C12.2067 6.18671 11.9867 6.41337 11.7067 6.41337Z"
                  fill="#0096B2"/>
            </svg>
            <input class="custom-control-input"
                   id="myOwnTask1"
                   type="checkbox"
                   :checked="params.ownTask"
                   @change="HandleParams('ownTask1', $event.target.checked)"
            >
            <label style="opacity: 0.6" class="custom-control-label nd_p_text14 " for="myOwnTask1">{{
                $t('allTasks')
              }}</label>
            <span v-if="params.ownTask === false" class="nd_status_inc nd_bg_yellow"
                  style="font-size: 10px; color: #fff">  {{ record.list.length }}</span>
          </button>


          <div class="" style="width: 1px; height: 24px; background-color: #DFE2E9"></div>

          <button :class="{ 'active': params.ownTask === true }"
                  @click="HandleParams('ownTask', !$event.target.classList.contains('active'))"
                  class="nd_btn_inc">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="#fff">
              <path
                  d="M12.2967 5.00498V8.99496C12.2967 9.64829 11.9467 10.255 11.3808 10.5875L7.91584 12.5883C7.35001 12.915 6.65001 12.915 6.07834 12.5883L2.61334 10.5875C2.04751 10.2608 1.69751 9.65413 1.69751 8.99496V5.00498C1.69751 4.35165 2.04751 3.74496 2.61334 3.41246L6.07834 1.41163C6.64418 1.08496 7.34418 1.08496 7.91584 1.41163L11.3808 3.41246C11.9467 3.74496 12.2967 4.34581 12.2967 5.00498Z"
                  stroke="#A2A5B9" stroke-linecap="round" stroke-linejoin="round"/>
              <path
                  d="M6.99991 6.41668C7.75056 6.41668 8.35908 5.80815 8.35908 5.05751C8.35908 4.30686 7.75056 3.69836 6.99991 3.69836C6.24927 3.69836 5.64075 4.30686 5.64075 5.05751C5.64075 5.80815 6.24927 6.41668 6.99991 6.41668Z"
                  fill="#A2A5B9" stroke-linecap="round" stroke-linejoin="round"/>
              <path
                  d="M9.33329 9.71829C9.33329 8.66829 8.28913 7.81665 6.99996 7.81665C5.71079 7.81665 4.66663 8.66829 4.66663 9.71829"
                  stroke="#A2A5B9" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input class="custom-control-input"
                   id="myOwnTask"
                   type="checkbox"
                   :checked="params.ownTask"
                   @change="HandleParams('ownTask', $event.target.checked)"
            >
            <label style="opacity: 0.6" class="custom-control-label nd_p_text14 "
                   for="myOwnTask">{{ $t('tasksIamAssigned') }}</label>
            <span v-if="params.ownTask === true" class="nd_status_inc nd_bg_yellow"
                  style="font-size: 10px; color: #fff">{{ record.list.length }}</span>
          </button>
        </div>
        <base-crud-table style="height: 390px !important;">
          <template #head>

            <tr class="bdr" style="background-color: #fff; border-bottom: 1px solid #DFE2E9;">
              <th class="width-75 sort" @click="HandleParams('sort', 'id')">
                <div class="az_crud_tb_th">

                  <div class="txt">#</div>

                  <template v-if="params.sortBy === 'id'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>

              <th class="sort" @click="HandleParams('sort', 'name')" :class="{'active': params.sortBy === 'name'}">
                <div class="az_crud_tb_th">
                  <div class="txt">{{ $t('name') }}</div>

                  <template v-if="params.sortBy === 'name'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>

              <th class="sort" @click="HandleParams('sort', 'columnName')"
                  :class="{'active': params.sortBy === 'columnName'}">
                <div class="az_crud_tb_th">
                  <div class="txt">{{ $t('columnName') }}</div>

                  <template v-if="params.sortBy === 'columnName'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>

              <th class="sort" @click="HandleParams('sort', 'projectName')"
                  :class="{'active': params.sortBy === 'projectName'}">
                <div class="az_crud_tb_th">
                  <div class="txt">{{ $t('repoerts.boardName') }}</div>

                  <template v-if="params.sortBy === 'projectName'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>

              <th class="sort" @click="HandleParams('sort', 'deadLine')"
                  :class="{'active': params.sortBy === 'deadLine'}">
                <div class="az_crud_tb_th">
                  <div class="txt">{{ $t('deadline') }}</div>

                  <template v-if="params.sortBy === 'deadLine'">
                    <i class="fa fa-angle-up" v-if="params.sortDirection === 'asc'"></i>
                    <i class="fa fa-angle-down" v-else></i>
                  </template>
                </div>
              </th>
              <th v-if="permissions.INDIVIDUAL_USER" class="sort">
                <div class="az_crud_tb_th" style="padding-left: 5px">
                  <div class="txt">{{ $t('status') }}</div>
                </div>
              </th>


              <th class="width-50"
                  v-if="permissions.TASK_READ
							|| permissions.TASK_UPDATE
							|| permissions.TASK_DELETE"
              >
              </th>
            </tr>
          </template>


          <template #body v-if="record.list.length > 0">
            <tr class="bdr"
                v-for="(item, index) in record.list"
                :class="{'danger': item.taskPriorityType && item.taskPriorityType.value === $store.state.TASK_PRIORITY_TYPE.HIGH}"
            >
              <td>
                <div class="az_crud_tb_txt" v-if="params.sortBy === 'id' && params.sortDirection === 'desc'">
                  {{ record.count - (params.page * params.perPage) - index }}
                </div>
                <div class="az_crud_tb_txt" v-else>
                  {{ (params.page * params.perPage) + (index + 1) }}
                </div>
              </td>

              <td >
                <div style=" cursor: pointer;
      max-height: 60px;
      overflow: hidden;
      width: 200px;
      word-break: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
align-items: center" class="az_crud_tb_txt"
                     @click="RouteOnPage(item)">{{ item.name }}
                </div>
              </td>

              <td>
                <div style="cursor: pointer" class="az_crud_tb_txt" @click="RouteOnPage(item)">
                  {{ $t(item.columnCodeName) | capitalize }}
                </div>
              </td>

              <td>
                <div class="nd_crud_tb_txt">
                  <p
                      style="
      cursor: pointer;
      max-height: 50px;
      overflow: hidden;
      max-width: 200px;
      word-break: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
    "
                      @click="RouteOnPage(item)"
                  >
                    {{ item.projectName }}
                  </p>
                </div>
              </td>

              <td v-if="permissions.TASK_READ || permissions.TASK_UPDATE || permissions.TASK_DELETE">
                <div class="d-flex align-items-center">
                  <div class="d-flex">
                    <div @click="RouteOnPage(item)" style="cursor: pointer">
                      <p class="nd_p_text12 nd_font_weight500" style="color: #48545D; width: 80px">
                        {{ item.deadLine.slice(0, 10) }}</p>
                    </div>
                  </div>

                </div>
              </td>
              <td v-if="permissions.INDIVIDUAL_USER">
                <div v-if="item.owner"
                     style="background-color: rgba(185,230,185,0.21); color: #005500; display: inline-block; padding: 5px 10px; text-align: center; border-radius: 4px; font-weight: 600;">
                  {{ $t('own') }}
                </div>
                <div v-else
                     style="background-color: rgba(230,185,185,0.21);display: inline-block; padding: 5px 10px; color: #550000; text-align: center; border-radius: 4px; font-weight: 600;">
                  {{ $t('invited') }}
                </div>
              </td>
              <td class="">
                <div class="d-flex align-items-center" style="position:relative; width: 100px; height: 53px;">
                  <div class="nd_drop_edit">
                    <div v-if="permissions.TASK_READ" class="forwartTo flex align-items-center mr-3"
                         @click="RouteOnPage(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z"
                              fill="currentColor"/>
                      </svg>
                    </div>
                    <div class="nd_block_edit ">
                      <div>
                        <div class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                               fill="none">
                            <path
                                d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
                                fill="#7A889B"/>
                          </svg>
                        </div>
                        <ul class="dropdown-menu">
                          <li class="nd_btn_edit dropdown-item"
                              v-if="permissions.TASK_READ" @click="RouteReadTask(item)">
                            <i class="fa fa-eye"></i>
                            {{ $t('view') }}
                          </li>
                          <li class="nd_btn_edit dropdown-item"
                              v-if="permissions.TASK_UPDATE" @click="RouteUpdateTask(item)">
                            <i class="fa fa-pencil"></i>
                            {{ $t('edit') }}
                          </li>
                          <li class="nd_btn_delete nd_btn_edit dropdown-item"
                              v-if="permissions.TASK_DELETE && item.owner"
                              @click="showDeleteTaskModal(item)"
                          >
                            <i class="fa fa-trash-o "></i>
                            {{ $t('delete') }}
                          </li>
                        </ul>
                      </div>

                    </div>
                    <div class="modal fade modal_column" :class="{'show':isDeleteModal}">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content delete-confirm-modal">
                          <div class="modal-header">
                            <h5 class="modal-title">{{ $t('areYouSure') }} </h5>
                            <button class="close" type="button" @click="isDeleteModal = false" data-dismiss="modal">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <p class="az_task_delete_txt">{{ $t('confirmDelete') }}</p>
                          </div>

                          <div class="d-flex justify-content-center p-3 modal-footer">
                            <button class="btn az_base_btn btn-default button-effect" type="button" data-dismiss="modal"
                                    @click="isDeleteModal = false">{{ $t('cancel') }}
                            </button>
                            <button class="btn az_base_btn btn-danger button-effect" type="button"
                                    @click="Delete(item.id)">{{ $t('delete') }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>

        </base-crud-table>
      </div>
    </template>

    <template #pagination>
      <paginate
          container-class="az_base_pag"
          page-class="page-item"
          prev-class="page-item"
          next-class="page-item"
          page-link-class="page-link"
          prev-link-class="page-link"
          next-link-class="page-link"
          prev-text="&laquo;"
          next-text="&raquo;"
          :page-count="record.pageCount"
          :value="params.page + 1"
          @input="HandleParams('page', $event)"
      ></paginate>
    </template>
  </base-crud-page-list>


</template>

<script>
import BaseCrudPageList from '../../../../components/BaseCrudPageList';
import BaseCrudTable from '../../../../components/BaseCrudTable';
import BaseInputSearch from '../../../../components/BaseInputSearch';
import BaseInputDeadlineType from '../../../../components/BaseInputDeadlineType';
import BaseInputDeadline from '../../../../components/BaseInputDeadline';
import BaseInputProject from '../../../../components/BaseInputProject';
import BaseInputColumn from '../../../../components/BaseInputColumn';
import Paginate from 'vuejs-paginate';
import {required} from "vuelidate/lib/validators";
import FormService from "@/services/FormService";

const DEFAULT_CREAT_MODEL = {
  name: '',
  projectId: null
}

export default {
  name: 'TasksList',
  components: {
    BaseInputColumn,
    BaseInputProject,
    BaseInputDeadline,
    BaseInputDeadlineType,
    // BaseCrudRange,
    BaseInputSearch,
    BaseCrudTable,
    BaseCrudPageList,
    Paginate,
  },
  props: {
    isFilter: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: [String, Object, Array],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deletedTaskName: '',
      disabledBtn: false,
      activeButton: null,
      createTaskModel: new FormService({
        name: '',
        projectId: 0
      }),
      params: {
        page: 0,
        perPage: 10,
        sortBy: 'createdAt',
        sortDirection: 'desc',
        ownTask: false,
        allSearch: null,
        projectId: null,
        columnId: null,
        deadLine: null,
        hasNoDeadline: null,
        inNextDay: null,
        inNextWeek: null,
        inNextMonth: null,
        overdue: null,
      },
      record: {
        list: [],
        count: 0,
        pageCount: 0,
      },
      projectSelected: 0,
      columnList: [],
      columnSelected: 0,
      taskId: null,
      projectList: [],
      isDeleteModal: false,
    };
  },
  validations() {
    return {
      createTaskModel: {
        name: {
          required
        },
        projectId: {
          required,
          validateProjectId: this.validateProjectId,
        }
      }
    };
  },
  watch: {
    'params.projectId'(val) {
      this.columnSelected = 0;
      this.columnList = [];

      if (val) {
        this.GetColumnList(val);
      }
    },
    'resource'(val) {
      this.recordList = val;
    },
  },
  created() {
    this.GetList();
  },
  mounted() {
    {
      this.getProjectList(0);
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
  },
  methods: {
    validateProjectId(value) {
      if (value !== 0) {
        return true
      } else {
        return false
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.save()
      }

      this.$emit('emit:submit', this.createTaskModel);

    },

    RouteOnPage(item) {
      this.$router.push({
        name: 'dashboard',
        params: {
          id: item.projectId,
          taskId: item.id,
        }
      })
    },
    toggleSettings() {
      this.$data.moreSettings = !this.$data.moreSettings
    },
    RouteUpdateTask(item) {
      this.$router.push({
        name: 'mainTasksUpdate',
        params: {
          id: item.id,
        }
      })
    },
    RouteReadTask(item) {
      this.$router.push({
        name: 'mainTasksRead',
        params: {
          id: item.id,
        }
      })
    },
    showDeleteTaskModal(item) {
      this.$data.isDeleteModal = true
      // record.list.fi
      // $('#modalDeleteTask').modal('show');
      this.deletedTaskName = item.name
      this.taskId = item.id;
    },
    HandleParams(type, val) {
      switch (type) {
        case 'search':
          this.params.allSearch = val ? val : null;
          break;

        case 'range':
          this.params.perPage = val;
          break;

        case 'page':
          window.scrollTo({top: 0, behavior: "smooth"})
          this.params.page = val - 1;
          break;

        case 'sort':
          if (this.params.sortBy === val) {
            this.params.sortDirection = this.params.sortDirection === 'asc' ? 'desc' : 'asc';
          }
          this.params.sortBy = val;
          break;

        case 'deadlineType':
          this.params.hasNoDeadline = val === 'hasNoDeadline' ? true : null;
          this.params.inNextDay = val === 'inNextDay' ? true : null;
          this.params.inNextWeek = val === 'inNextWeek' ? true : null;
          this.params.inNextMonth = val === 'inNextMonth' ? true : null;
          this.params.overdue = val === 'overdue' ? true : null;
          break;

        case 'deadline':
          this.params.deadLine = val ? this.$moment(val).format('YYYY-MM-DD') : null;
          break;

        case 'project':
          this.params.projectId = val === 0 ? null : val;
          this.params.columnId = null;
          break;

        case 'column':
          this.params.columnId = val === 0 ? null : val;
          break;

        case 'ownTask':
          this.params.ownTask = true;
          break;

        case 'ownTask1':
          this.params.ownTask = false;
          break;
      }

      if (type !== 'page') {
        this.params.page = 0;
      }

      this.GetList();
    },
    GetList() {
      // this.$store.dispatch('getTaskPermissions', this.params)
      this.$api
          .get('tasks', {
            params: this.params,
          })
          .then(response => {
            this.record.list = response.data.data;
            this.record.count = response.data.totalCount;
            this.record.pageCount = Math.ceil(response.data.totalCount / this.params.perPage);
            this.$store.commit('setTaskPermissions', response.data.permissions)
          });
    },
    Delete() {
      this.$api
          .delete('tasks/' + this.taskId)
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.isDeleteModal = false
            this.$notification.success(this.$t('successfullyDeleted'));
            this.GetList();
            $('#modalDeleteTask').modal('hide');
            this.taskId = null;
          }).catch(error => {
        this.$notification.error(error.response.data.error_message.title);
        this.isDeleteModal = false
      });


    },

    GetColumnList(projectId) {
      this.$api
          .get('projectColumns/selection', {
            params: {
              projectId: projectId,
            }
          })
          .then(response => {
            this.columnList = response.data.data;
          });
    },
    getProjectList(organizationId) {
      this.$api
          .get('projects/projects', {
            params: {
              organizationId: organizationId,
            }
          })
          .then(response => {
            this.projectList = response.data.data;
          });
    },
    closeNotFoundModal() {
      $('#projectNotFound').modal('hide')
    },
    clearModal() {
      this.createTaskModel.Reset()
      this.$v.$reset()
      $('#modalTasks').modal('hide')
    },
    check() {
      if (this.projectList.length) {
        $('#modalTasks').modal('show')
      } else {
        $('#projectNotFound').modal('show')
      }
    },
    async save() {
      this.disabledBtn = true
      try {
        await this.$api
            .post('tasks', this.createTaskModel)
            .then(response => {
              this.isCreateTasksModal = false;
              this.$notification.success(this.$t('SuccessfullyCreated'));
              this.GetList();
              this.clearModal()
            })
      } catch (error) {
        this.$notification.error(error.response.data.error_message.title)

      } finally {
        this.disabledBtn = false

      }

    },
  },
  computed: {
    permissions() {
      return this.$store.state.taskPermissions
    },
    console() {
      return console
    }
  },
};
</script>
<style scoped>
.active {
  background-color: #d6eaec;

}
</style>
